/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AdminSection_organization$ref = any;
type LocaleSwitcher_viewer$ref = any;
type OrgSelect_organization$ref = any;
type OrgSelect_viewer$ref = any;
type OrganizationSection_organization$ref = any;
type Search_viewer$ref = any;
type SettingsSection_organization$ref = any;
type SettingsSection_viewer$ref = any;
type SignoutButton_viewer$ref = any;
type TensionProcessing_organization$ref = any;
type UpgradeLink_organization$ref = any;
type UserSection_organization$ref = any;
type UserSection_viewer$ref = any;
type YourOrganizationSection_organization$ref = any;
type YourOrganizationSection_viewer$ref = any;
type YourProfileAndSettings_viewer$ref = any;
type YourRolesSection_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SidebarView_organization$ref: FragmentReference;
declare export opaque type SidebarView_organization$fragmentType: SidebarView_organization$ref;
export type SidebarView_organization = {|
  +exceedsFreePlan: boolean,
  +viewerIsMember: boolean,
  +viewerIsAdmin: boolean,
  +viewer: {|
    +routes: {|
      +homepagePath: string
    |},
    +$fragmentRefs: LocaleSwitcher_viewer$ref & Search_viewer$ref & UserSection_viewer$ref & SettingsSection_viewer$ref & YourOrganizationSection_viewer$ref & YourProfileAndSettings_viewer$ref & SignoutButton_viewer$ref & OrgSelect_viewer$ref,
  |},
  +$fragmentRefs: UpgradeLink_organization$ref & OrganizationSection_organization$ref & YourRolesSection_organization$ref & UserSection_organization$ref & TensionProcessing_organization$ref & SettingsSection_organization$ref & YourOrganizationSection_organization$ref & AdminSection_organization$ref & OrgSelect_organization$ref,
  +$refType: SidebarView_organization$ref,
|};
export type SidebarView_organization$data = SidebarView_organization;
export type SidebarView_organization$key = {
  +$data?: SidebarView_organization$data,
  +$fragmentRefs: SidebarView_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SidebarView_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exceedsFreePlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "homepagePath",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LocaleSwitcher_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Search_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserSection_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SettingsSection_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "YourOrganizationSection_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "YourProfileAndSettings_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignoutButton_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgSelect_viewer"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpgradeLink_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrganizationSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "YourRolesSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TensionProcessing_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "YourOrganizationSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdminSection_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgSelect_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'd3933f55578847fac210e91e1bae6f82';

module.exports = node;
